export default __webpack_public_path__ + "static/media/s4.527731e4.jpg";